<div class="content">
	<ngx-spinner type="ball-scale-multiple" size="medium" [name]="blockLoader"></ngx-spinner>

        <div>
            <div style="text-align: center;">
                <button class="searchBtn" mat-button color="primary" (click)="addNewLevel()">
                    <mat-icon style="margin-right: 0.2rem; width: 24px !important; height: 24px !important; font-size: 24px !important;">add_circle</mat-icon>
                    Add Hierarchy Level
                </button>
            </div>


            <div class="mat-elevation-z8">
                <table style="margin-top: 24px;" mat-table [dataSource]="settingLevelNamesDataSource"
                    class="mat-elevation-z8">

                    <!-- <ng-container matColumnDef="position">
                        <th mat-header-cell *matHeaderCellDef> No. </th>
                        <td mat-cell *matCellDef="let element">1 </td>
                    </ng-container> -->

                    <!-- Position Column -->
                <ng-container matColumnDef="id">
                    <th mat-header-cell *matHeaderCellDef> No. </th>
                    <td mat-cell *matCellDef="let element, let i = index">
                    {{this.paginator.pageIndex == 0 ? i + 1 : 1 + i + this.paginator.pageIndex * this.paginator.pageSize}}
                    </td>
                </ng-container>

                    <ng-container matColumnDef="countries">
                        <th mat-header-cell *matHeaderCellDef> Levels </th>
                        <td mat-cell *matCellDef="let element"> {{element}} </td>
                    </ng-container>

                    Edit Button Column
                    <ng-container matColumnDef="edit">
                        <th mat-header-cell *matHeaderCellDef> Edit </th>
                        <td mat-cell *matCellDef="let element, let i = index">
                            <button mat-icon-button color="primary" (click)="addNewLevel(element, i)">
                                <mat-icon style="color: #29c96c">create</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <!-- Delete Column -->
                    <ng-container matColumnDef="delete">
                        <th mat-header-cell *matHeaderCellDef> Delete </th>
                        <td mat-cell *matCellDef="let element; let i = index">
                            <button mat-icon-button color="primary" (click)="deleteLevel(element, i)">
                                <mat-icon style="color: #FE8C6E">delete</mat-icon>
                            </button>
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedCountryColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedCountryColumns;"></tr>
                </table>

                <mat-paginator [pageSizeOptions]="[20]" showFirstLastButtons></mat-paginator>
            </div>
        </div>
    </div>